// copied from packages/ui/src/components/FlavorFinder/components/Consent/index.ts
export * from "./FlavorFinderConsent";
